import React, { memo, FC } from "react"
import { Attendee, Maybe } from "../../../../generated/graphql"
import css from "./AttendeeAlert.module.css"

type AttendeeAlertProps = {
    selectedAttendeeId?: string
    attendees?: Maybe<Array<Attendee>>
    selfBookerCourse?: boolean
}

const AttendeeAlert: FC<AttendeeAlertProps> = ({ selectedAttendeeId, attendees, selfBookerCourse }) => {
    const bookerHasAttendees = attendees?.length && attendees.length > 0
    const attendeeIsSelected = Boolean(selectedAttendeeId !== undefined)

    if (!bookerHasAttendees) {
        if (selfBookerCourse) {
            return <div className={css.root}>{"Bitte tragen Sie Ihr Geburtsdatum ein."}</div>
        }
        return <div className={css.root}>{"Bitte lege zunächst einen Teilnehmer für den Kurs an."}</div>
    }

    if (!attendeeIsSelected) {
        return <div className={css.root}>{"Kein Teilnehmer ausgewählt"}</div>
    }

    return null
}

export default memo(AttendeeAlert)
